import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { B as n } from "./Button-1eab0617.js";
import { Title as t } from "./Title.js";
import "react";
function d({ goToLastPage: o }) {
  return /* @__PURE__ */ r("div", { className: "flex", children: /* @__PURE__ */ i("div", { children: [
    /* @__PURE__ */ r(t, { children: "Oops! Página não encontrada!" }),
    /* @__PURE__ */ r(n, { onClick: () => o(), children: "Voltar para página anterior" })
  ] }) });
}
export {
  d as NotFound
};
